const {ChangeColumnTypeConfiguration} = require("./configuration/change-column-type-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const ChangeColumnTypeStepPanelTabs = {
    configuration: ChangeColumnTypeConfiguration,
    preview: PreviewTab,
};
exports.ChangeColumnTypeStepPanelTabs = ChangeColumnTypeStepPanelTabs;
